define.alias("checkout/components/seamless-checkout-table/line-item", "calendar/components/seamless-checkout-table/line-item");